import React, { useState, useEffect } from 'react';
import { Header, Footer } from '../../Container';
import { Container, Col, Button, ListGroup } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import '../../../assets/css/Cogen.css';
import { ReqGet } from '../../../config/Requests';

function JobRejectors() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [rejectorList, setRejectorList] = useState([]);
	// const id = window.location.href.split("/").reverse()[1]
	const [request, setRequest] = useState({
		isInitiated: false,
		isSuccess: false,
		isFailed: false,
	});

	useEffect(() => {
		setRequest({ isInitiated: true });
		ReqGet(`job/${id}/rejectors`)
			.then(res => {
				setRejectorList(res.data);
				console.log(res.data);
				setRequest({ isInitiated: false, isSuccess: true });
			})
			.catch(err => console.log(err.response));
		setRequest({ isSuccess: false, isFailed: true });
	}, []);

	return (
		<Container fluid='true'>
			<Header type='member' />
			<Container className='flex-column mt-5 notification align-content-inherit'>
				<Col md='auto'>
					<Button
						className='btn_cancel'
						variant='primary'
						onClick={() => navigate('/')}
					>
						Back{' '}
					</Button>
					<Button
						className='btn_cancel'
						variant='primary'
						onClick={() => navigate(`/job/${id}/applicants`)}
						style={{ width: '11%', float: 'right' }}
					>
						Job Detail{' '}
					</Button>
				</Col>
				<div className='wrapper'>
					<br /> <br />
					<h5 className='title'>Applicants that Declined Job Opportunity</h5>
					<br />
				</div>
				<div className='wrapper'>
					<br />
					<ListGroup>
						{rejectorList.length === 0 && request.isSuccess === true ? (
							<ListGroup.Item>No Declined Applicants</ListGroup.Item>
						) : (
							rejectorList.map((item, i) => {
								return (
									<>
										<ListGroup.Item>
											<div
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													flexDirection: 'row',
													textAlign: 'center',
												}}
											>
												{item.pivot.status == 'decline' ? (
													<p>
														<b>Client</b> has rejected{' '}
														<em style={{ fontWeight: 800 }}>{item.fullname}</em>{' '}
														for this Job.
													</p>
												) : (
													<p>
														{' '}
														<em>
															<b>Member</b>
														</em>{' '}
														has rejected this Job.
													</p>
												)}
												<Button
													onClick={() =>
														navigate(`/job/${id}/applicants/view-profile`, {
															params: { profile: item },
														})
													}
												>
													View member profile
												</Button>
											</div>
										</ListGroup.Item>
									</>
								);
							})
						)}
					</ListGroup>
					<br />
				</div>
			</Container>
			<Footer />
		</Container>
	);
}

export default JobRejectors;
